import {
  createPandaAgentFactory,
  createPandaSearchAgentFactory,
  FetchImpl,
} from 'shared/panda/agent/panda-agent';

// HttpAgent's default fetch omits credentials, so force `include` — panda-service
// reads the auth cookie only on a credentialed cross-origin request.
const credentialedFetch: FetchImpl = (url, requestInit) =>
  fetch(url, { ...requestInit, credentials: 'include' });

export const createPandaAgent = createPandaAgentFactory({ fetch: credentialedFetch });

export const createPandaSearchAgent = createPandaSearchAgentFactory({ fetch: credentialedFetch });
